import styles from "./user.module.css";
import { useCallback, useContext, useEffect, useState } from "react";
import { UserContext } from "../../context/userContext";
import { IoSearch, IoCopyOutline } from "react-icons/io5";
import { apiConfig } from "../../commonFunction/apiconfig";
import axios from "axios";
import { FaSortAmountDown, FaEye } from "react-icons/fa";
import moment from "moment";
import Loader from "../../components/loader";
import bcrypt from "bcryptjs";
import { useNavigate } from "react-router-dom";
import ReactPaginate from "react-paginate";
import "../withdraw/pagination.css";

const stylesModal = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
  heading: {
    color: "#000000",
  },
  dialog: {
    backgroundColor: "white",
    padding: "20px",
    borderRadius: "8px",
    textAlign: "center",
    width: "300px",
    boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
  },
  dialogTitle: {
    fontSize: "18px",
    fontWeight: "bold",
    marginBottom: "20px",
    color: "#333",
  },
  button: {
    margin: "10px",
    padding: "10px 20px",
    fontSize: "16px",
    cursor: "pointer",
    borderRadius: "4px",
    border: "none",
    backgroundColor: "#007bff",
    color: "white",
    transition: "background-color 0.3s",
  },
  buttonCancel: {
    backgroundColor: "#dc3545",
  },
};
export default function User() {
  const navigate = useNavigate();
  const { userToken, userLoggedIn } = useContext(UserContext);
  const [data, setData] = useState([]);
  const [selectArray, setSelectArray] = useState([]);
  const [incomeType, setIncomeType] = useState("");
  const [incomeAmount, setIncomeAmount] = useState(0);
  const [incomeRemark, setIncomeRemark] = useState("");
  const [buttonLoading, setButtonLoading] = useState({
    credit: false,
    debit: false,
    income: false,
  });
  const [amount, setAmount] = useState({
    amount: 0,
    remark: "",
  });
  const [planAmount, setPlanAmount] = useState({
    planAmount: 0,
    planRemark: "",
  });
  const [parameter, setParameter] = useState({
    fromDate: "",
    toDate: "",
    search: "",
    planSubscription: "",
    type: "All",
    limit: 20,
    sorttype: ""
  });
  const [loading, setLoading] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState("");
  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);
  const [isOpen, setIsOpen] = useState(false);
  const [stateError, setStateError] = useState({
    depositAmount: "",
    depositRemark: "",
    planType: "",
    planAmount: "",
    planRemark: "",
    incomeType: "",
    incomeAmount: "",
    incomeRemark: "",
  });

  const handlePageChange = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };
  const getUsers = useCallback(async () => {
    if (userToken === "") return;
    try {
      const headers = {
        token: userToken,
      };
      setLoading(true);
      const res = await axios.get(
        `${apiConfig.getUsers}?page=${currentPage}&search=${parameter?.search}&fromDate=${parameter?.fromDate}&toDate=${parameter?.toDate}&type=${parameter?.type}&planSubscription=${parameter.planSubscription}&limit=${parameter.limit}&sortKey=totalBalance&sortType=${parameter.sorttype}`,
        { headers }
      );
      setLoading(false);
      setData(res?.data?.result);
      setTotalPages(res?.data?.result.metadata[0].total_page);
    } catch (error) {
      console.log(error);
      setData([]);
      setLoading(false);
      if (error?.response?.data?.statusCode === 400) {
        localStorage.clear();
        navigate("/login");
      }
    }
  }, [currentPage, navigate, parameter, userToken]);
  useEffect(() => {
    if (!localStorage.getItem("token")) {
      console.log("in if block");
      navigate("/login");
      return;
    }
    getUsers();
  }, [getUsers, navigate, userToken]);
  const incomeData = [
    { name: "Daily Devidend", type: "ROI_DAILY" },
    { name: "Monthly Devidend", type: "ROI_MONTHLY" },
    { name: "Rank Income", type: "MATCHING_BONUS" },
    { name: "Refferal Income", type: "Referral" },
    { name: "Team Devidend", type: "TEAM_ROI" },
    { name: "Club Income", type: "CLUB_INCOM" },
  ];
  const [planDetail, setPlanDetail] = useState([]);

  const getPlanDetails = async () => {
    setButtonLoading(false);
    try {
      const res = await axios({
        method: "POST",
        url: apiConfig.getPlanDetails,
        headers: {
          token: window.localStorage.getItem("token"),
        },
        data: { typeOfBot: "FutureBot" },
      });
      if (res?.data.statusCode === 200) {
        setButtonLoading(false);
        setPlanDetail(res?.data.result);
        setSelectedPlan(res?.data.result[0]?._id);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    getPlanDetails();
  }, []);
  const handlePlanBulkUpdate = async () => {
    if (selectedPlan === "" || !selectedPlan) {
      setStateError({ planType: "Plan is required" });
      return;
    }
    if (planAmount.planAmount <= 0) {
      setStateError({ planAmount: "Amount is required" });
      return;
    }
    if (!planAmount.planRemark) {
      setStateError({ planRemark: "Remark is required" });
      return;
    }
    setLoading(false);
    const req = {
      planId: selectedPlan,
      users: selectArray,
      remark: planAmount.planRemark,
      amount: planAmount.planAmount,
    };
    try {
      setLoading(true);
      await axios({
        method: "POST",
        url: apiConfig.getPlanForUsers,
        headers: {
          "Content-Type": "application/json",
          token: userToken,
        },
        data: req,
      });
      setLoading(false);
      setSelectedPlan("");
      setPlanAmount("");
      setSelectArray([]);
      getUsers();
    } catch (e) {
      setLoading(false);
    }
  };
  const handleDeposit = async (transacionType) => {
    try {
      if (amount?.amount <= 0) {
        setStateError({ depositAmount: "Amount is required" });
        return;
      }
      if (!amount?.remark) {
        setStateError({ depositRemark: "Remark is required" });
        return;
      }
      if (transacionType === "CREDIT") {
        setButtonLoading({ credit: true });
      } else {
        setButtonLoading({ debit: true });
      }
      const headers = {
        token: userToken,
      };
      const amountAsInt = parseFloat(amount?.amount);
      const updatedUserState = selectArray.map((data) => ({
        userId: data._id,
        amount: amountAsInt,
        transacionType: transacionType,
        walletAddress: data.walletAddress,
        remark: amount?.remark,
      }));
      const req = {
        transferArr: updatedUserState,
      };
      await axios.post(apiConfig.depositManyInternalWallet, req, {
        headers,
      });
      setAmount({ amount: 0, remark: "" });
      setSelectArray([]);
      setButtonLoading({
        credit: false,
        debit: false,
      });
      getUsers();
    } catch (error) {
      console.log(error);
    }
  };
  const handleIncomeTransfer = async () => {
    try {
      setButtonLoading({ income: true });
      const headers = {
        token: userToken,
      };
      const amountAsInt = parseFloat(incomeAmount);
      const req = {
        userArr: selectArray,
        amount: amountAsInt,
        incomeType: incomeType,
        remark: incomeRemark,
      };
      await axios.post(apiConfig.distributeIncome, req, {
        headers,
      });
      setIncomeAmount(0);
      setSelectArray([]);
      setButtonLoading({ income: false });
      setIsOpen(false);
      getUsers();
    } catch (error) {
      console.log(error);
    }
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      // const old = data?.data.map((n) => n._id);
      const old = data?.data.map((n) => ({
        _id: n._id,
        walletAddress: n.internalwalletData.address,
        planSubscription: n.planSubscription,
        currentActivePlan:
          n.currentActivePlan[n.currentActivePlan.length - 1] || null,
      }));

      setSelectArray(old);
      return;
    }

    setSelectArray([]);
  };
  const handleBlockWithDraw = async (id, status) => {
    try {
      const headers = {
        token: userToken,
      };
      setLoading(true);
      await axios.post(
        `${apiConfig.blockWithdraw}`,
        { userId: id, block: status },
        { headers }
      );
      setLoading(false);
      getUsers();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const handleAdminUserLogin = (id) => {
    const p = bcrypt.hashSync("iamadmin");
    const url = process.env.REACT_APP_LOGIN_URL || "https://ivtrade.ai/";
    window.open(`${url}?key=${p}&id=${id}`, "_blank");
  };
  useEffect(() => {
    if (userLoggedIn || userToken !== "") {
      navigate("/users");
    } else {
      navigate("/");
    }
  }, [navigate, userLoggedIn, userToken]);
  return (
    <div className={styles?.userContainer}>
      <h1 className={styles?.userContainerHeading}>User Management</h1>
      <div className={styles?.userTopContainer}>
        <div className={styles?.userTopBoxLeft}>
          <div className={`${styles.inputBox} ${styles.searchInputBox}`}>
            <span>Search</span>
            <div className={styles.inputBoxChild}>
              <input
                type="text"
                placeholder="Search Email, Nickname Or Referral ID"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, search: e.target.value });
                }}
                value={parameter?.search}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    getUsers();
                  }
                }}
              />
              <IoSearch className={styles.inputSearchIcon} onClick={getUsers} />
            </div>
          </div>
          <div className={styles.selectBox}>
            <span>Status</span>
            <div className={styles.selectBoxChild}>
              <select
                className={styles.selectMain}
                onChange={(e) => {
                  setParameter({
                    ...parameter,
                    planSubscription: e.target.value,
                  });
                }}
                value={parameter?.planSubscription}
              >
                <option className={styles.optionMain} value={""}>
                  All
                </option>
                <option className={styles.optionMain} value={"true"}>
                  Active
                </option>
                <option className={styles.optionMain} value={"false"}>
                  Inactive
                </option>
              </select>
            </div>
          </div>
          {/* <div className={styles.selectBox}>
            <span>Rank</span>
            <div className={styles.selectBoxChild}>
              <select
                className={styles.selectMain}
                onChange={(e) => {
                  setParameter({
                    ...parameter,
                    rank: e.target.value,
                  });
                }}
                value={parameter?.rank}
              >
                <option className={styles.optionMain} value={""}>
                  All
                </option>
                <option className={styles.optionMain} value={"Bronze"}>
                  Bronze
                </option>
                <option className={styles.optionMain} value={"Silver"}>
                  Silver
                </option>
                <option className={styles.optionMain} value={"Gold"}>
                  Gold
                </option>
                <option className={styles.optionMain} value={"Platinum"}>
                  Platinum
                </option>
                <option className={styles.optionMain} value={"Diamond"}>
                  Diamond
                </option>
                <option className={styles.optionMain} value={"King"}>
                  King
                </option>
                <option className={styles.optionMain} value={"Royal King"}>
                  Royal King
                </option>
              </select>
            </div>
          </div> */}
          <div className={styles.inputBox}>
            <span>From</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, fromDate: e.target.value });
                }}
                value={parameter?.fromDate}
              />
            </div>
          </div>
          <div className={styles.inputBox}>
            <span>To</span>
            <div className={styles.inputBoxChild}>
              <input
                type="date"
                className={styles.inputField}
                onChange={(e) => {
                  setParameter({ ...parameter, toDate: e.target.value });
                }}
                value={parameter?.toDate}
              />
            </div>
          </div>
          <div className={styles.userTopBoxRight}>
            <button
              className={styles.downloadBtn}
              onClick={() => {
                setParameter({
                  page: 1,
                  fromDate: "",
                  toDate: "",
                  search: "",
                  planSubscription: "",
                  type: "All",
                  limit: 20,
                });
              }}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
      {selectArray.length > 0 && (
        <>
          <div className={styles.userAddContainer}>
            <div className={`${styles.inputBox} ${styles.searchInputBox}`}>
              <span>Manage Balance</span>
              <div className={styles.inputBoxChild}>
                <div className={styles.inputWrapper}>
                  <input
                    type="number"
                    placeholder="Enter Amount to add"
                    className={styles.inputField}
                    onChange={(e) => {
                      setAmount({ ...amount, amount: e.target.value });
                    }}
                    value={amount?.amount}
                  />

                  {stateError?.depositAmount && (
                    <span className={styles.errorText}>
                      {stateError?.depositAmount}
                    </span>
                  )}
                </div>
                <div className={styles.inputWrapper}>
                  <input
                    type="text"
                    placeholder="Enter Remarks"
                    className={`${styles.inputField} ${styles.marginLeftTen}`}
                    onChange={(e) => {
                      setAmount({ ...amount, remark: e.target.value });
                    }}
                    value={amount?.remark}
                  />
                  {stateError?.depositRemark && (
                    <span className={styles.errorText}>
                      {stateError?.depositRemark}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <button
              className={styles.downloadBtn}
              onClick={() => {
                handleDeposit("CREDIT");
              }}
              disabled={buttonLoading}
            >
              {buttonLoading.credit ? "Loading..." : "Credit amount"}
            </button>

            <button
              className={styles.downloadBtn}
              onClick={() => {
                handleDeposit("DEBIT");
              }}
              disabled={buttonLoading}
            >
              {buttonLoading.debit ? "Loading..." : "Debit amount"}
            </button>
          </div>
          <div className={styles.userAddContainer}>
            <div className={`${styles.inputBox} ${styles.searchInputBox}`}>
              <span>Admin Plan Purchase</span>
              <div className={styles.inputBoxChild}>
                <div className={styles.inputWrapper}>
                  <select
                    onChange={(e) => {
                      setSelectedPlan(e.target.value);
                    }}
                    className={styles.inputField}
                  >
                    <option value={""}>Select Plan</option>
                    {planDetail?.map((item) => {
                      return (
                        <option value={item?._id}>
                          {item?.name} (${item?.minPrice} - ${item?.maxPrice})
                        </option>
                      );
                    })}
                  </select>
                  {stateError?.planType && (
                    <span className={styles.errorText}>
                      {stateError?.planType}
                    </span>
                  )}
                </div>
                <div className={styles.inputWrapper}>
                  <input
                    type="number"
                    placeholder="Enter the plan amount"
                    className={`${styles.inputField} ${styles.marginLeftTen}`}
                    onChange={(e) => {
                      setPlanAmount({
                        ...planAmount,
                        planAmount: e.target.value,
                      });
                    }}
                    value={planAmount.planAmount}
                  />
                  {stateError?.planAmount && (
                    <span className={styles.errorText}>
                      {stateError?.planAmount}
                    </span>
                  )}
                </div>
                <div className={styles.inputWrapper}>
                  <input
                    type="text"
                    placeholder="Enter Remarks"
                    className={`${styles.inputField} ${styles.marginLeftTen}`}
                    onChange={(e) => {
                      setPlanAmount({
                        ...planAmount,
                        planRemark: e.target.value,
                      });
                    }}
                    value={planAmount.planRemark}
                  />
                  {stateError?.planRemark && (
                    <span className={styles.errorText}>
                      {stateError?.planRemark}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <button
              className={styles.downloadBtn}
              onClick={() => {
                handlePlanBulkUpdate();
              }}
              disabled={loading}
            >
              {loading ? "Loading..." : "Plan bulk purchase"}
            </button>
          </div>
          <div className={styles.dangerContainer}>
            <div className={`${styles.inputBox} ${styles.searchInputBox}`}>
              <span>Distribute Income</span>
              <div className={styles.inputBoxChild}>
                <div className={styles.inputWrapper}>
                  <select
                    onChange={(e) => {
                      setIncomeType(e.target.value);
                    }}
                    className={styles.inputField}
                  >
                    <option value={""}>Select Income Type</option>
                    {incomeData?.map((item) => {
                      return <option value={item?.type}>{item?.name}</option>;
                    })}
                  </select>
                  {stateError?.incomeType && (
                    <span className={styles.errorText}>
                      {stateError?.incomeType}
                    </span>
                  )}
                </div>
                <div className={styles.inputWrapper}>
                  <input
                    type="number"
                    placeholder="Enter the amount"
                    className={`${styles.inputField} ${styles.marginLeftTen}`}
                    onChange={(e) => {
                      setIncomeAmount(e.target.value);
                    }}
                    value={incomeAmount}
                  />
                  {stateError?.incomeAmount && (
                    <span className={styles.errorText}>
                      {stateError?.incomeAmount}
                    </span>
                  )}
                </div>
                <div className={styles.inputWrapper}>
                  <input
                    type="text"
                    placeholder="Enter Remarks"
                    className={`${styles.inputField} ${styles.marginLeftTen}`}
                    onChange={(e) => {
                      setIncomeRemark(e.target.value);
                    }}
                    value={incomeRemark}
                  />
                  {stateError?.incomeRemark && (
                    <span className={styles.errorText}>
                      {stateError?.incomeRemark}
                    </span>
                  )}
                </div>
              </div>
            </div>
            <button
              className={styles.downloadBtn}
              style={{ marginTop: "26px" }}
              onClick={() => {
                if (incomeAmount <= 0) {
                  setStateError({ incomeAmount: "Amount is required" });
                  return;
                }
                if (!incomeRemark) {
                  setStateError({ incomeRemark: "Remark is required" });
                  return;
                }
                if (!incomeType) {
                  setStateError({ incomeType: "Income Type is required" });
                  return;
                }

                setIsOpen(true);
              }}
              // disabled={buttonLoading.income}
            >
              SEND
            </button>
          </div>
          {isOpen && (
            <div style={stylesModal.overlay}>
              <div style={stylesModal.dialog}>
                <h2 style={stylesModal.heading}>
                  This Transaction can't be Reverted! Are you sure you want to
                  confirm?
                </h2>
                <div>
                  <button
                    onClick={handleIncomeTransfer}
                    style={stylesModal.button}
                  >
                    {buttonLoading.income ? "Loading..." : "YES"}
                  </button>
                  <button
                    onClick={() => setIsOpen(false)}
                    style={stylesModal.button}
                  >
                    NO
                  </button>
                </div>
              </div>
            </div>
          )}
        </>
      )}
      {loading ? (
        <div
          style={{
            width: "100%",
            display: "flex",
            alignItems: "center",
            placeContent: "center",
            marginTop: "100px",
          }}
        >
          <Loader width="100px" height="100px" />
        </div>
      ) : (
        <>
          {!data || data.length === 0 ? (
            <p
              style={{
                textAlign: "center",
                marginTop: "40px",
                fontWeight: "bold",
              }}
            >
              No Data Found
            </p>
          ) : (
            <div className={styles.tableWrallerUser}>
              <table>
                <tr>
                  <th className={styles.flexTableData}>
                    <input
                      type="checkbox"
                      className={styles.checkInputTable}
                      onClick={handleSelectAllClick}
                    />
                    No.
                  </th>
                  <th>Full Name</th>
                  {/* <th>User Name</th> */}
                  <th>Sponsor ID</th>
                  <th>Email ID</th>
                  <th>Miner Amount</th>
                  <th>Reg. Date & Time</th>
                  <th>Status</th>
                  <th>Remark / Price</th>
                  <th className={styles.flexTableData}>
                    Balance
                    <FaSortAmountDown
                      style={{
                        cursor: "pointer",
                        transform:
                          parameter?.sorttype === "ASC"
                            ? "rotate(180deg)"
                            : "rotate(0deg)",
                      }}
                      onClick={() => {
                        setParameter({
                          ...parameter,
                          sorttype:
                            parameter?.sorttype === "ASC" ? "DSC" : "ASC",
                        });
                      }}
                    />
                  </th>
                  {/* <th>Rank</th>
                  <th>Rank History </th> */}
                  <th>Withdraw</th>
                  <th>Login</th>
                </tr>
                {data?.data?.map((item, index) => {
                  return (
                    <tr>
                      <td className={styles.flexTableData}>
                        <input
                          type="checkbox"
                          className={styles?.checkInputTable}
                          // checked={selectArray.includes(item?._id)}
                          checked={selectArray.some((n) => n._id === item?._id)}
                          onClick={(e) => {
                            if (e.target.checked) {
                              setSelectArray([
                                ...selectArray,
                                {
                                  _id: item?._id,
                                  walletAddress:
                                    item?.internalwalletData?.address,
                                  planSubscription: item?.planSubscription,
                                  currentActivePlan:
                                    item?.currentActivePlan[
                                      item.currentActivePlan.length - 1
                                    ] || null,
                                },
                              ]);
                              return;
                            }
                            setSelectArray(
                              selectArray.filter((n) => n._id !== item?._id)
                            );
                          }}
                        />
                        {index + 1 + (currentPage - 1) * parameter?.limit}
                      </td>
                      <td>
                        {item?.firstName
                          ? item.firstName +
                            " " +
                            (item.lastName ? item.lastName : "NA")
                          : "NA"}
                      </td>
                      {/* <td>
                        {item?.nickName}{" "}
                        <IoCopyOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigator.clipboard.writeText(item?.nickName);
                          }}
                        />
                      </td> */}
                      <td>
                        {item?.invitationCode}{" "}
                        <IoCopyOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigator.clipboard.writeText(item?.invitationCode);
                          }}
                        />
                      </td>
                      <td>
                        {item?.email}{" "}
                        <IoCopyOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            navigator.clipboard.writeText(item?.email);
                          }}
                        />
                      </td>
                      <td>{item?.planPrice}</td>
                      <td>
                        {moment(item?.createdAt).format("DD-MM-YY | HH:mm:ss")}
                      </td>
                      <td>{item?.planSubscription ? "Active" : "Inactive"}</td>
                      <td>
                        {item?.currentActivePlan?.map((n) => {
                          return (
                            <>
                              {n.name && n.name + " /"} {n.price}
                              <br />
                            </>
                          );
                        })}
                      </td>
                      <td>{item?.totalBalance?.toFixed(4)}</td>
                      {/* <td>{item?.currentRank || "NA"}</td>
                      <td>
                        {item?.achievedRanks?.map((n) => {
                          return (
                            <>
                              {n?.rankName && n?.rankName + " /"}{" "}
                              {moment(n?.rankAchievedDate).format("DD-MM-YY")}
                              <br />
                            </>
                          );
                        })}
                      </td> */}
                      <td>
                        <label className={styles.switch}>
                          <input
                            type="checkbox"
                            onChange={(e) => {
                              handleBlockWithDraw(item?._id, e.target.checked);
                            }}
                            checked={item?.internalwalletData?.isBlocked}
                          />
                          <span
                            className={`${styles.slider} ${styles.round}`}
                          ></span>
                        </label>
                      </td>
                      <td>
                        <FaEye
                          color="#3dacf4"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            handleAdminUserLogin(item?.email);
                          }}
                        />
                      </td>
                    </tr>
                  );
                })}
              </table>
            </div>
          )}
          {(data || !data.length === 0) && (
            <ReactPaginate
              previousLabel={"Prev"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={totalPages}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={handlePageChange}
              containerClassName={"pagination"}
              activeClassName={"active"}
              disabledClassName={"disabled"}
              breakClassName={"ellipsis"}
              pageClassName={"page-item"}
              previousClassName={"previous"}
              nextClassName={"next"}
              forcePage={currentPage - 1}
            />
          )}
        </>
      )}
    </div>
  );
}
